import { FetchResult, QueryResult, useQuery } from '@apollo/client'
import { client } from '../../..'
import { OBJECTIVES_IN_MEETING, OBJECTIVE_DTO_LIST, EXISTING_DEV_TARGETS_TO_BE_CLOSED } from '../../../graphql/objectives/ObjectiveQuery'
import {
  SAVE_OBJECTIVE_IN_MEETING,
  SAVE_OBJECTIVE,
  DUPLICATE_AND_DISMISS_OBJECTIVE_IN_MEETING,
  CLOSE_OUTDATED_TARGETS,
  DELETE_OBJECTIVE_IN_MEETING,
} from '../../../graphql/objectives/ObjectiveMutation'
import {
  GetTargetsTemplatesQuery,
  GetTargetsTemplatesQueryVariables,
  ObjectiveInput,
  SaveObjectiveInMeetingMutation,
  SaveObjectiveInMeetingMutationVariables,
  SaveObjectiveMutation,
  SaveObjectiveMutationVariables,
  DuplicateAndDimissObjectiveInMeetingMutation,
  DuplicateAndDimissObjectiveInMeetingMutationVariables,
  CloseOutdatedTargetsMutationVariables,
  CloseOutdatedTargetsMutation,
  DeleteObjectiveInMeetingMutation,
  DeleteObjectiveInMeetingMutationVariables,
} from '../../../types'
import { TARGETS_TEMPLATE } from './Queries'

export const targetModalSaveTarget = async (employeeId: string, target: ObjectiveInput): Promise<FetchResult<SaveObjectiveMutation>> => {
  return await client.mutate<SaveObjectiveMutation, SaveObjectiveMutationVariables>({
    mutation: SAVE_OBJECTIVE,
    variables: {
      employeeId,
      objective: target,
    },
    refetchQueries: [
      {
        query: OBJECTIVE_DTO_LIST,
        variables: {
          employeeId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const targetModalSaveTargetInMeeting = async (
  meetingId: string,
  target: ObjectiveInput,
): Promise<FetchResult<SaveObjectiveInMeetingMutation>> => {
  return await client.mutate<SaveObjectiveInMeetingMutation, SaveObjectiveInMeetingMutationVariables>({
    mutation: SAVE_OBJECTIVE_IN_MEETING,
    variables: {
      meetingId,
      objective: target,
    },
    refetchQueries: [
      {
        query: OBJECTIVES_IN_MEETING,
        variables: {
          meetingId: meetingId,
        },
      },
      {
        query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
        variables: {
          meetingId: meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const deleteObjectiveApi = async (globalId: string, meetingId: string): Promise<FetchResult<DeleteObjectiveInMeetingMutation>> => {
  return await client.mutate<DeleteObjectiveInMeetingMutation, DeleteObjectiveInMeetingMutationVariables>({
    mutation: DELETE_OBJECTIVE_IN_MEETING,
    variables: {
      globalId: globalId,
      meetingId: meetingId,
    },
    refetchQueries: [
      {
        query: OBJECTIVES_IN_MEETING,
        variables: {
          meetingId,
        },
      },
      {
        query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
        variables: {
          meetingId: meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const targetModalDuplicateAndDismissOrDeleteInMeeting = async (
  objective: ObjectiveInput,
  meetingId: string,
): Promise<FetchResult<DuplicateAndDimissObjectiveInMeetingMutation>> => {
  return await client.mutate<DuplicateAndDimissObjectiveInMeetingMutation, DuplicateAndDimissObjectiveInMeetingMutationVariables>({
    mutation: DUPLICATE_AND_DISMISS_OBJECTIVE_IN_MEETING,
    variables: {
      objective,
      meetingId,
    },
    refetchQueries: [
      {
        query: OBJECTIVES_IN_MEETING,
        variables: {
          meetingId: meetingId,
        },
      },
      {
        query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
        variables: {
          meetingId: meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const closeOutdatedTargets = async (meetingId: string): Promise<FetchResult<CloseOutdatedTargetsMutation>> => {
  return client.mutate<CloseOutdatedTargetsMutation, CloseOutdatedTargetsMutationVariables>({
    mutation: CLOSE_OUTDATED_TARGETS,
    variables: {
      meetingId,
    },
    refetchQueries: [
      {
        query: OBJECTIVES_IN_MEETING,
        variables: {
          meetingId: meetingId,
        },
      },
      {
        query: EXISTING_DEV_TARGETS_TO_BE_CLOSED,
        variables: {
          meetingId: meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export const useTargetsTemplates = (employeeId: string): QueryResult<GetTargetsTemplatesQuery, GetTargetsTemplatesQueryVariables> => {
  return useQuery<GetTargetsTemplatesQuery, GetTargetsTemplatesQueryVariables>(TARGETS_TEMPLATE, {
    variables: { employeeId },
    fetchPolicy: 'network-only',
  })
}
